// extracted by css-extract-rspack-plugin
export default {"heading":"_50eb5fbf","body":"_71124a67","itemStrong":"_ff9d3b1","itemBody":"_2b4cd6d2","item":"_fb4156e2","list":"_68d38795"};